/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import * as c from './constant';

export const getTransactionList = (id, payload, callback) =>
  req.list(
    c.GET_BUILDING_TRANSACTION_LIST,
    `/api/v1/rpt/administrator/buildings/building_applications/${id}/building_transactions`,
    payload,
    callback
  );

  export const showData = (id, payload, callback) =>
    req.item(
      c.SHOW_DATA,
      `/api/v1/rpt/administrator/buildings/building_applications/${id}`,
      payload,
      callback
    );